import React from 'react';
import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';
import { spinnable } from 'components/UIKit/decorators';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';

export type ReadGroupsMetadataDownloadContainerType = {
  isSpinning: boolean,
  setIsSpinning: () => {},
  downloadAllMetadata: () => {},
  downloadSingleMetadata: () => {},
  downloadAll: boolean,
  readGroup: any,
  marginOffset: any,
  children: any,
}

function ReadGroupsMetadataDownloadContainer({
  setIsSpinning,
  isSpinning,
  downloadAllMetadata,
  downloadSingleMetadata,
  downloadAll,
  readGroup,
  marginOffset,
  children,
}: ReadGroupsMetadataDownloadContainerType): React.Element {
  return (
    <DownloadDropdown
      marginOffset={marginOffset}
      setIsSpinning={setIsSpinning}
      download={
        async format => {
          if (downloadAll) {
            await downloadAllMetadata(format);
          } else await downloadSingleMetadata(readGroup, format);
        }
      }
      formats={['tsv', 'json']}
      >
      <Button
        disabled={isSpinning}
        PrefixComponent={isSpinning
              ? <Spinner style={{ height: '1rem', width: '1rem', marginRight: '2px' }} />
              : <DownloadIcon />}
        >
        { children || 'Metadata' }
      </Button>
    </DownloadDropdown>
  );
}

export default canDownloadEntities(spinnable(ReadGroupsMetadataDownloadContainer));
